import { render, staticRenderFns } from "./directPacking.vue?vue&type=template&id=9d794288&scoped=true&"
import script from "./directPacking.vue?vue&type=script&lang=js&"
export * from "./directPacking.vue?vue&type=script&lang=js&"
import style0 from "./directPacking.vue?vue&type=style&index=0&id=9d794288&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d794288",
  null
  
)

export default component.exports